export type UserCoords = {
  latitude: number
  longitude: number
}

const MOCK_USER_COORDS_TTL_MS = 30 * 60 * 1000 // 30 minutes
const MOCK_USER_COORDS_LS_ID = 'mock_user_coords'

export async function loadMockUserCoords<T = any>(): Promise<T | {}> {
  if (process.env.NODE_ENV !== 'development') return {}

  try {
    const module = (await import('../../mockUserCoords')) as {
      MOCK_MAP_COORDS: T
      MOCK_USER_COORDS: T
    }
    return module.MOCK_MAP_COORDS
  } catch (err) {
    console.log('User Coords Mock file not found. Skipping...')
    return {}
  }
}

export const setMockUserCoordsStorage = (coords: UserCoords) => {
  const payload = {
    value: coords,
    expiry: Date.now() + MOCK_USER_COORDS_TTL_MS,
  }

  localStorage.setItem(MOCK_USER_COORDS_LS_ID, JSON.stringify(payload))
}

export const getMockUserCoordsStorage = (): UserCoords | null => {
  const raw = localStorage.getItem(MOCK_USER_COORDS_LS_ID)

  if (!raw) return null

  try {
    const parsed = JSON.parse(raw)

    if (Date.now() > parsed.expiry) {
      localStorage.removeItem(MOCK_USER_COORDS_LS_ID)
      return null
    }

    return parsed.value
  } catch {
    return null
  }
}

export const clearMockUserCoordsStorage = () => {
  localStorage.removeItem(MOCK_USER_COORDS_LS_ID)
}
